// extracted by mini-css-extract-plugin
module.exports = {"o-activity-section":"ActivityList_o-activity-section__3wvj-","a-activity-list-title":"ActivityList_a-activity-list-title__2rPAD"};